module.exports = __webpack_public_path__ + "img/avp_bck_alt_small@2x.609c7f8.jpg";